export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9787.063caca6.jpg";